'use strict';

module.exports = Backbone.Model.extend({
    connectorsInitialized: false,
    actualConnector: null,
    firstLogin: false,
    logged: false,
    loggedOnHttps: false,
    isLegacyUser: false,
    isBlockedUser: false,
    isMembership: false,
    isPersistentLogin: true,
    isDynpack: Odigeo.Utils.isRequestApp('dp'),
    membershipDisplayName: '',
    activeUrl: '',
    trackCategory: '',
    trackPage: '',
    recaptchaLoginWidgetID: null,
    recaptchaPassRecoveryWidgetID: null,
    recaptchaWidgetID: {},
    recaptchaRendered: {},
    requestData: {},
    loginType: null,
    socialToken: null,
    action: null,
    models: {
        user: {},
        login: {
            password: '',
        },
    },
    loginActions: {
        password: 'login',
        facebook: 'loginWithFacebook',
        google: 'loginWithGoogle',
    },
    defaults: {
        recaptchaLogin: false,
        recaptchaPassRecovery: false,
    },
    errors: {
        'STA_003': 'notverifiedaccount',
        'STA_011': 'notverifiedaccount',
        'STA_009': 'accountBlocked',
        'STA_000': 'accountBlocked',
        'STA_002': 'legacyUser',
        'FND_000': 'emailError',
        'FND_001': 'emailError',
        'AUTH_000': 'loginError',
        'VAL_000': 'empty',
        'VAL_002': 'invalid',
        'VAL_003': 'invalid',
        'VAL_024': 'invalid',
        'VAL_052': 'remoteError',
        'STA_006': 'socialErrorFacebook',
        'STA_007': 'socialErrorGoogle',
        'STA_008': 'socialError',
        'AUTH_002': 'permissions',
        'AUTH_005': 'authErrorFacebook',
        'AUTH_006': 'authErrorGoogle',
        'AUTH_008': 'socialPass',
        'AUTH_010': 'tokenError',
        'AUTH_100': 'remoteError',
        'AUTH_101': 'remoteError',
        'VAL_028': 'format',
        'VAL_008': 'tokenError',
        'FB': 'tokenError',
        'RCP_001': 'recaptchaError',
        'STO_000': 'remoteError',
        'UNL_007': 'velocityRules',
        'OPRIME_001': 'emailMatching',
        'facebook': 'tokenErrorFacebook',
        'google': 'tokenErrorGoogle',
        'default': 'requestError',
    },
    trackErrors: {
        'permisions': 'sso_email_authentication_facebook_error',
        'default': 'sso_email_already_used_facebook_error',
    },
    libs: {
        auth2: null,
    },
});
